import RefreshOutlined from '@mui/icons-material/RefreshOutlined';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import { LoadingWrapper } from 'library/components/controls/loaders/LoadingWrapper';

interface PdfPreviewPaneProps {
	isPreview: boolean;
	isLoadingPreview: boolean;
	previewUrl: string;
	generateButtonLabel: string;
	objectName?: string;
	onGenerateClick: () => void;
}

/**
 * Generic preview pane reused by PDF print dialogs. Shows a "generate preview"
 * button until the user opts in, then renders the generated PDF blob inside an
 * <object> viewer.
 */
export const PdfPreviewPane = ({
	isPreview,
	isLoadingPreview,
	previewUrl,
	generateButtonLabel,
	objectName = 'pdfPreview',
	onGenerateClick,
}: PdfPreviewPaneProps) => (
	<Box
		sx={(theme) => ({
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			flex: isPreview ? 1 : '0 1 500px',
			bgcolor: 'background.default',

			[theme.breakpoints.down('md')]: {
				display: 'none',
				flex: 0,
			},
		})}>
		{!isPreview ? (
			<Button
				size="large"
				variant="outlined"
				onClick={onGenerateClick}
				startIcon={<RefreshOutlined />}
				sx={{
					bgcolor: 'background.paper',
					borderRadius: 4,
				}}>
				{generateButtonLabel}
			</Button>
		) : (
			<LoadingWrapper loading={isLoadingPreview}>
				<object
					data={`${previewUrl}`}
					type="application/pdf"
					name={objectName}
					title="pdf preview"
					width="100%"
					height="100%"></object>
			</LoadingWrapper>
		)}
	</Box>
);
